import React from 'react';
import PropTypes from 'prop-types';
import ReactTextAreaWrapper from '../Wrappers/ReactTextAreaWrapper';
import ReactFileReader from 'react-file-reader';
import classNames from 'classnames';

export default class GeneralPost extends React.Component {
  render() {
    const {
      charLimit,
      counter,
      croppedImage,
      field,
      handleImage,
      onChange,
      removeImage,
      valid
    } = this.props;

    const body = field('body');

    return <div>
      <div className="mb-4 text-tomato">
        All fields required unless marked as optional
      </div>
      <div
        className={classNames('textarea-counter mb-4', {
          'over-limit': counter(body, charLimit) < 0
        })}
      >
        <ReactTextAreaWrapper
          className="b-0"
          input={body}
          onChange={onChange}
          valid={valid}
          placeholder="Start writing..."
        />
        <div className="count">{counter(body, charLimit)}</div>
      </div>
      <div className="image-container">
        {croppedImage && (
          <img className="img-fluid" src={croppedImage} alt="post" />
        )}
        <div className="d-flex justify-content-between my-2 align-items-center">
          <ReactFileReader
            base64={true}
            handleFiles={handleImage}
          >
            <div className="btn-pill d-inline-flex align-items-center image-select px-3 py-1">
              <i className="image-select-icon fa fa-camera mr-1" />
              <span>{croppedImage ? 'Replace' : 'Add'} Photo</span>
            </div>
          </ReactFileReader>
          {croppedImage && (
            <div
              className="pull-right text-danger"
              onClick={removeImage}
            >
              Remove Photo
            </div>
          )}
        </div>
      </div>
    </div>;
  }
}

GeneralPost.defaultProps = {
  charLimit: 200
};

GeneralPost.propTypes = {
  charLimit: PropTypes.number,
  counter: PropTypes.func.isRequired,
  field: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  valid: PropTypes.func.isRequired,
  croppedImage: PropTypes.array,
  handleImage: PropTypes.func.isRequired,
  removeImage: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Social/GeneralPost.js